exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".desktop-push-list .bannerLogo img{max-height:60px}.desktop-push-list .priorityLabel{margin-top:12px;text-align:right}.desktop-push-list .identi{color:#e65454;position:absolute;margin-left:-10px;line-height:20px}.desktop-push-list .aline{margin:0 2px 0 6px;color:#ddd;font-size:12px;vertical-align:middle;height:10px;display:inline-block;overflow:hidden;width:1px;background:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/configPush/brand-manager/brand-manager-list/brand-manager-list.scss
// module id = 530
// module chunks = 2